import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'default-header',
  templateUrl: './header-default.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HeaderDefaultComponent implements OnInit {

  constructor() { }

  public disabled:boolean = false;
  public status:{isopen:boolean} = {isopen: false};

  public toggled(open:boolean):void {
    console.log('Dropdown is now: ', open);
    console.log('Status: ' + status);
  }

  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
    console.log('status: ' + this.status.isopen);
  }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/layouts/header-default.component.ts